import QRCode from 'qrcode';

/**
 * ISO/IEC 18004 Compliant SVG QR Code Generator for Event Ticketing & Passes.
 * Generates fully scannable QR code matrices as clean, sharp SVG strings or Data URLs.
 */

export function generateQRCodeSVG(text, options = {}) {
    const {
        size = 256,
        color = '#0f172a',
        bgColor = '#ffffff',
        margin = 3,
        errorCorrectionLevel = 'M'
    } = options;

    const str = String(text || 'OMNIVASO-TICKET');
    let qr;
    try {
        qr = QRCode.create(str, { errorCorrectionLevel });
    } catch (e) {
        qr = QRCode.create(str, { errorCorrectionLevel: 'L' });
    }

    const modCount = qr.modules.size;
    const modData = qr.modules.data;
    const totalGrid = modCount + margin * 2;

    let pathData = '';
    for (let r = 0; r < modCount; r++) {
        for (let c = 0; c < modCount; c++) {
            if (modData[r * modCount + c]) {
                const x = margin + c;
                const y = margin + r;
                pathData += `M${x},${y}h1v1h-1z `;
            }
        }
    }

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${totalGrid} ${totalGrid}" width="${size}" height="${size}" shape-rendering="crispEdges" style="background-color: ${bgColor}; border-radius: 8px; display: inline-block;">
        <rect width="100%" height="100%" fill="${bgColor}" />
        <path d="${pathData}" fill="${color}" />
    </svg>`;

    return svg;
}

export function generateQRCodeDataURL(text, options = {}) {
    const svg = generateQRCodeSVG(text, options);
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
